import { PageHeader } from '@organisms';
import { Alert, Button, Col, Divider, Form, Row } from 'antd';
import { useMemo } from 'react';
import { FormProvider } from 'react-hook-form';

import { TabComponent } from 'src/app/components/antd/TabComponent';

import { TenantFormTabs } from '../../types/tenantForm.types';
import { DomainsForm } from './components/DomainsForm';
import { TenantFormSection } from './components/formSection.types';
import { InitialDataForm } from './components/InitialDataForm';
import { SettingsForm } from './components/SettingsForm';
import { useTenantForm } from './hooks/useTenantForm';

export const FormByTab: Record<TenantFormTabs, TenantFormSection> = {
  initialData: InitialDataForm,
  settings: SettingsForm,
  domains: DomainsForm,
};

export const TenantForm = () => {
  const {
    isEditing,
    isLoadingEditData,
    activeTab,
    changeActiveTab,
    headerInfo,
    tenantFormMethods,
    handleTenantFormSubmit,
    tenantTabList,
    handleGoBackToTenantList,
    isModifiedOnEdit,
    isLoadingFields,
    isLoadingSubmit,
  } = useTenantForm();

  const ActiveFormComponent = useMemo(() => FormByTab[activeTab], [activeTab]);
  const isLoading = false;
  return (
    <>
      <PageHeader
        backToPath='/tenants'
        title={headerInfo.title}
        subTitle={headerInfo.subTitle}
      />
      <TabComponent
        tabList={tenantTabList}
        onChangeTab={item => changeActiveTab(item as TenantFormTabs)}
        defaultActiveKey={activeTab}
      />
      <FormProvider {...tenantFormMethods}>
        <Form
          disabled={isLoading ? true : false}
          layout='vertical'
          onFinish={handleTenantFormSubmit}
          style={{ marginBottom: '-10%' }}
        >
          {isModifiedOnEdit && (
            <Alert
              message='O tenant foi editado, não se esqueça de salvar as alterações.'
              description=''
              type='info'
              showIcon
            />
          )}
          <ActiveFormComponent
            isEditing={isEditing}
            isLoadingEditData={isLoadingEditData}
            isLoadingFields={isLoadingFields}
          />
          <Divider />
          <Row justify='end'>
            <Col>
              <Button
                htmlType='button'
                style={{ paddingInline: '16px', marginInlineEnd: '12px' }}
                onClick={() => {
                  handleGoBackToTenantList();
                }}
              >
                Cancelar
              </Button>
              <Button
                type='primary'
                htmlType='submit'
                style={{ paddingInline: '16px' }}
                disabled={isLoadingSubmit}
                loading={isLoadingSubmit}
              >
                Salvar
              </Button>
            </Col>
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};
